// @ts-check
import { checkEnrichedName } from '../utils/string';

/**
 * Model for Match Odds
 */
export default class TopEventsMatchesOddsModel {
  /**
   * @param {import('./interface').ApiTopEventMarket} data - raw api data
   * @param {string} homeTeam - raw api home team
   * @param {string} guestTeam - raw api away team
   */
  constructor(data, homeTeam = "", guestTeam = "") {
    /**
     * Odds ID
     * @type {number}
     */
    this.marketId = data.id;
    /**
     * Odds Name (Market Name?)
     * @type {string}
     */
    this.marketName = data.n;
    /**
     * Enriched Market Name
     * @type {string}
     */
    this.enrichedMarketName = checkEnrichedName(data.emn, homeTeam, guestTeam, data.sbv);
    /**
     * If this odd is combination with other odds
     * Single = 1, can be played only single
     * Unique = 2, can be played as a single at least
     * Trebles = 3, can be played in a combination with at least three other
     * Quadruple = 4, can be played in a combination with at least four other
     * Quintuple = 5 can be played in a combination with at least five
     * @type {number}
     */
    this.isCombo = data.c;
    /**
     * Outcomes array
     * @type {import('./top-events-match-outcome.model').default[]}
     */
    this.outcomes = [];
    /**
     * Flag if market is cashout
     * @type {boolean}
     */
    this.cashout = data.ca || false;
  }
}